import React from 'react';
import Link from 'gatsby-link';
import { Button } from 'reactstrap';

export default (props) => {
  var { color, ...props } = props;
  color = color || 'primary';
  return (
    <Button {...props} tag={Link} color={color}>
        {props.children}
    </Button>
  );
};



// WEBPACK FOOTER //
// ./src/components/ButtonLink.js